export default {
  "guide_body_text": {
    "HK": "桌面元件",
    "TW": "桌面小工具",
    "ar_SA": "عنصر واجهة الشاشة الرئيسية",
    "de_DE": "Startbildschirm-Widget",
    "en_US": "Home Screen Widget",
    "es_ES": "Widget para la pantalla de inicio",
    "fr_FR": "Widget d'écran d'accueil",
    "hi_IN": "Home Screen Widget",
    "in_ID": "Widget Layar Beranda",
    "ja_JP": "Home Screen Widget",
    "ko_KR": "Home Screen Widget",
    "ms_MY": "Widget Skrin Utama",
    "pt_PT": "Widget de Tela Inicial",
    "ru_RU": "Виджет рабочего стола",
    "th_TH": "วิดเจ็ตหน้าโฮม",
    "tr_TR": "Ana Ekran Araç Takımı",
    "ur": "ہوم اسکرین وجٹ",
    "uz": "Asosiy ekran vidjeti",
    "vi_VN": "Tiện Ích Màn Hình Chính",
    "zh_CN": "桌面组件"
  },
  "guide_faq_android_answer1": {
    "HK": "可以。你可長按小工具，點擊編輯小工具來變更查看對象。目前僅支援查看最近贈送過人氣禮物的玩家。",
    "TW": "可以。長按小工具、點按編輯小工具，再變更查看對象即可。目前僅支援查看最近贈送過人氣禮物的玩家。",
    "ar_SA": "نعم. يمكنك تحديد التقدم الذي ترغب في رؤيته من خلال إعدادات عنصر الواجهة. لا يمكن حاليًا إلا عرض تقدم اللاعبين الذين أرسلوا هدايا الشعبية مؤخرًا.",
    "de_DE": "Ja. In den Widget-Einstellungen kannst du festlegen, wessen Fortschritt angezeigt werden soll. Momentan kannst du nur den Fortschritt von Spielern anzeigen lassen, die dir kürzlich Beliebtheitsgeschenke gesendet haben.",
    "en_US": "Yes. You can change whose progress you'd like to see from the widget settings. Currently, you can only view the progress of players who have recently sent Popularity Gifts.",
    "es_ES": "Sí. En la configuración del widget puedes elegir de qué persona quieres ver el progreso. Actualmente, solo puedes ver el progreso de quienes hayan enviado Regalos de Popularidad recientemente.",
    "fr_FR": "Oui. Vous pouvez choisir le joueur dont vous souhaitez voir la progression dans les paramètres du widget. À l'heure actuelle, seule la progression des joueurs qui ont récemment envoyé des cadeaux de popularité est disponible.",
    "hi_IN": "Yes. You can change whose progress you'd like to see from the widget settings. Currently, you can only view the progress of players who have recently sent Popularity Gifts.",
    "in_ID": "Ya. Kamu bisa memilih progres siapa yang ditampilkan dari pengaturan widget. Saat ini, kamu hanya bisa melihat progres pemain yang baru saja mengirimkan Hadiah Popularitas.",
    "ja_JP": "Yes. You can change whose progress you'd like to see from the widget settings. Currently, you can only view the progress of players who have recently sent Popularity Gifts.",
    "ko_KR": "Yes. You can change whose progress you'd like to see from the widget settings. Currently, you can only view the progress of players who have recently sent Popularity Gifts.",
    "ms_MY": "Ya. Anda boleh memilih kemajuan pemain yang ingin dilihat dalam tetapan widget. Buat masa ini, anda hanya boleh melihat kemajuan pemain yang menghantar Hadiah Populariti baru-baru ini.",
    "pt_PT": "Sim. Você pode escolher de quem ver o progresso nas configurações do widget. No momento, você só pode ver o progresso de jogadores que enviaram Presentes de Popularidade recentemente.",
    "ru_RU": "Да. В настройках виджета можно изменить, чей прогресс вы хотите видеть. В настоящее время вы можете просматривать прогресс только тех игроков, которые недавно отправляли подарки популярности.",
    "th_TH": "แน่นอน คุณสามารถเปลี่ยนความก้าวหน้าของคนที่คุณต้องการดูได้ที่การตั้งค่าวิดเจ็ต ขณะนี้ คุณจะดูได้แค่ความก้าวหน้าของผู้เล่นที่ส่งของขวัญความนิยมในระยะนี้เท่านั้น",
    "tr_TR": "Evet. Araç takımı ayarlarından ilerlemesini görmek istediğin oyuncuları düzenleyebilirsin. Şu anda sadece yakın zamanda Popülerlik hediyeleri gönderen oyuncuların ilerlemesini görebilirsin.",
    "ur": "ہاں۔ آپ وجٹ سیٹنگز میں جا کر یہ تبدیل کر سکتے ہیں کہ آپ کس کی پیش رفت کو دیکھنا چاہیں گے۔ فی الحال، آپ صرف ان پلیئرز کی پیش رفت کو دیکھ سکتے ہیں جنہوں نے حال ہی میں مقبولیت کے گفٹس ارسال کیے ہیں۔",
    "uz": "Ha. Vidjet sozlamalar orqali kimlarning rivojini ko‘rishni o‘zgartirishingiz mumkin. Hozirda faqat yaqinda Mashhurlik hadyalarini yuborgan o‘yinchilar rivojini ko‘ra olasiz.",
    "vi_VN": "Được. Bạn có thể thay đổi tiến trình của ai mà bạn muốn xem từ cài đặt tiện ích. Hiện tại, bạn chỉ có thể xem tiến trình của những người chơi gần đây đã gửi Quà Điểm Nổi Tiếng.",
    "zh_CN": "可以的，可以通过长按小组件，点击编辑小组件，更改查看对象。目前仅支持查看最近赠送过人气礼物的玩家。"
  },
  "guide_faq_android_answer1_replace_text": {
    "HK": "15",
    "TW": "15",
    "ar_SA": "15",
    "de_DE": "15",
    "en_US": "15",
    "es_ES": "15",
    "fr_FR": "15",
    "hi_IN": "15",
    "in_ID": "15",
    "ja_JP": "15",
    "ko_KR": "15",
    "ms_MY": "15",
    "pt_PT": "15",
    "ru_RU": "15",
    "th_TH": "15",
    "tr_TR": "15",
    "ur": "15",
    "uz": "15",
    "vi_VN": "15",
    "zh_CN": "15"
  },
  "guide_faq_android_answer2": {
    "HK": "由於系統限制，數據一般會有延遲。但請放心，這不會影響遊戲內人氣禮物相關功能的正常使用。",
    "TW": "由於系統限制，資料通常會有延遲。但請放心，不會影響遊戲內人氣禮物相關功能的正常使用。",
    "ar_SA": "قد يحدث تأخر في تلقي البيانات بسبب قيود النظام. ولكن لا تقلق، فهذا لن يؤثر على استخدام هدايا الشعبية داخل اللعبة.",
    "de_DE": "Aufgrund von Systembeschränkungen kann es zu einer Verzögerung bei den Daten kommen. Keine Sorge, die Beliebtheitsgeschenke im Spiel sind davon natürlich nicht betroffen.",
    "en_US": "Due to system limitations, there may be a delay in the data. However, rest assured that this does not affect the use of Popularity Gifts in-game.",
    "es_ES": "Debido a limitaciones del sistema, puede haber demora en los datos. Sin embargo, esto no afectará el uso de los Regalos de Popularidad en el juego.",
    "fr_FR": "En raison des limitations du système, le traitement des données peut être retardé. Cependant, l'utilisation des cadeaux de popularité dans le jeu n'en sera pas affectée.",
    "hi_IN": "Due to system limitations, there may be a delay in the data. However, rest assured that this does not affect the use of Popularity Gifts in-game.",
    "in_ID": "Akibat adanya batasan sistem, keterlambatan data bisa saja terjadi. Jangan khawatir, keterlambatan ini tidak akan memengaruhi penggunaan Hadiah Popularitas dalam game.",
    "ja_JP": "Due to system limitations, there may be a delay in the data. However, rest assured that this does not affect the use of Popularity Gifts in-game.",
    "ko_KR": "Due to system limitations, there may be a delay in the data. However, rest assured that this does not affect the use of Popularity Gifts in-game.",
    "ms_MY": "Kelewatan data mungkin berlaku disebabkan had sistem. Namun begitu, ini tidak akan menjejaskan penggunaan Hadiah Populariti dalam game.",
    "pt_PT": "Devido a limitações do sistema, pode haver um atraso nos dados. Isso não afeta o uso de Presentes de Popularidade no jogo.",
    "ru_RU": "В связи с ограничениями системы возможна задержка при получении данных. Однако это не повлияет на использование подарков популярности в игре.",
    "th_TH": "จากข้อจำกัดด้านระบบ ส่งผลให้ข้อมูลอาจมีความล่าช้าอยู่บ้าง อย่างไรก็ตาม สามารถวางใจได้ว่าสิ่งนี้จะไม่ส่งผลต่อการใช้งานฟีเจอร์ของขวัญความนิยมภายในเกม",
    "tr_TR": "Sistem kısıtlamalarından dolayı verilerin güncellenmesinde gecikme meydana gelebilir. Ancak bu durum, oyunda Popülerlik hediyelerinin kullanımını etkilemez.",
    "ur": "سسٹم کی حدود کی وجہ سے، ڈیٹا میں تاخیر ہو سکتی ہے۔ تاہم، بے فکر رہیں کیونکہ یہ ان-گیم مقبولیت کے گفٹس کے استعمال پر اثر انداز نہیں ہوتا۔",
    "uz": "Tizim cheklovlari sababli ma’lumotlarda kechikish bo‘lishi mumkin. Lekin xotirjam bo‘ling, bu o‘yin ichida Mashhurlik hadyalaridan foydalanishda ta’sir qilmaydi.",
    "vi_VN": "Do hạn chế của hệ thống, dữ liệu có thể bị chậm trễ. Tuy nhiên, hãy yên tâm rằng điều này không ảnh hưởng đến việc sử dụng Quà Điểm Nổi Tiếng biến trong trò chơi.",
    "zh_CN": "因为系统限制，数据一般会有延迟。但请放心，不会影响游戏内人气礼物相关功能的正常使用。"
  },
  "guide_faq_android_answer3": {
    "HK": "唔會，小元件只喺螢幕亮起時以一定頻率更新。",
    "TW": "不會，小工具只在螢幕亮起時以一定頻率重新整理。",
    "ar_SA": "لا، إذ لا تُحدَّث بيانات عنصر الواجهة إلا خلال فترات زمنية محددة عندما تكون الشاشة قيد التشغيل.",
    "de_DE": "Nein, das Widget aktualisiert die Daten in regelmäßigen Abständen, wenn der Bildschirm aktiviert ist.",
    "en_US": "Nope, the widget only refreshes data at a specific interval when the screen is on.",
    "es_ES": "¡Para nada! El widget solo actualiza la información en un intervalo específico cuando la pantalla está encendida.",
    "fr_FR": "Non, le widget n'actualise les données qu'à une certaine fréquence lorsque l'écran est allumé.",
    "hi_IN": "Nope, the widget only refreshes data at a specific interval when the screen is on.",
    "in_ID": "Tidak. Widget hanya memperbarui data setiap jangka waktu tertentu saat layar dalam keadaan menyala.",
    "ja_JP": "Nope, the widget only refreshes data at a specific interval when the screen is on.",
    "ko_KR": "Nope, the widget only refreshes data at a specific interval when the screen is on.",
    "ms_MY": "Tidak, widget hanya menyegar semula data pada selang masa tertentu apabila skrin dihidupkan.",
    "pt_PT": "Não, o widget só é atualizado em espaços de tempo específicos quando a tela estiver ligada.",
    "ru_RU": "Нет, виджет обновляет данные раз в определенный промежуток времени и только при включенном экране.",
    "th_TH": "ไม่ใช้ โดยวิดเจ็ตจะรีเฟรชข้อมูลเป็นระยะๆ เมื่อหน้าจอเปิดอยู่เท่านั้น",
    "tr_TR": "Hayır, araç takımı cihaz ekranın açıkken sadece belirli aralıklarla veri yeniler.",
    "ur": "نہیں، وجٹ میں صرف اس مخصوص مدت پر ڈیٹا ریفریش ہوتا ہے جب اسکرین آن ہوتی ہے۔",
    "uz": "Yoʻq, bu vidjet faqat ekran yoniq vaqtda maʼlumotlarni muayyan intervalda yangilaydi.",
    "vi_VN": "Không, tiện ích chỉ làm mới dữ liệu trong thời gian nhất định khi màn hình bật.",
    "zh_CN": "不会，小组件只在屏幕亮起时以一定频率刷新。"
  },
  "guide_faq_android_answer3_replace_text": {
    "HK": "15",
    "TW": "15",
    "ar_SA": "15",
    "de_DE": "15",
    "en_US": "15",
    "es_ES": "15",
    "fr_FR": "15",
    "hi_IN": "15",
    "in_ID": "15",
    "ja_JP": "15",
    "ko_KR": "15",
    "ms_MY": "15",
    "pt_PT": "15",
    "ru_RU": "15",
    "th_TH": "15",
    "tr_TR": "15",
    "ur": "15",
    "uz": "15",
    "vi_VN": "15",
    "zh_CN": "15"
  },
  "guide_faq_android_content1": {
    "HK": "除了自己的對決進度，我還可在小工具上查看其他對決進度嗎？",
    "TW": "除了自己的對決進度，我也可以在小工具上查看其他的對決進度嗎？",
    "ar_SA": "هل يمكنني رؤية تقدم لاعب آخر في معركة الشعبية من خلال عنصر الواجهة؟",
    "de_DE": "Kann ich den Beliebtheitskampf-Fortschritt anderer Spieler im Widget sehen?",
    "en_US": "Can I view someone else's Popularity Battle progress in the widget?",
    "es_ES": "¿Puedo ver el progreso de la Batalla de Popularidad de alguien más en el widget?",
    "fr_FR": "Puis-je voir la progression des Combats de popularité d'un autre joueur dans le widget ?",
    "hi_IN": "Can I view someone else's Popularity Battle progress in the widget?",
    "in_ID": "Apakah saya bisa melihat progres Popularity Battle pemain lain dari widget?",
    "ja_JP": "Can I view someone else's Popularity Battle progress in the widget?",
    "ko_KR": "Can I view someone else's Popularity Battle progress in the widget?",
    "ms_MY": "Bolehkah saya melihat Pertempuran Populariti pemain lain di widget?",
    "pt_PT": "Posso ver o progresso de Batalha de Popularidade de outro jogador no widget?",
    "ru_RU": "Могу ли я посмотреть на виджете прогресс битвы популярности другого игрока?",
    "th_TH": "ฉันสามารถดูความก้าวหน้าการท้าดวลความนิยมของผู้อื่นผ่านทางวิดเจ็ตได้หรือไม่?",
    "tr_TR": "Araç takımından başka bir oyuncunun Popülerlik Savaşı ilerlemesini görebilir miyim?",
    "ur": "کیا میں وجٹ میں کسی اور کی مقبولیت کی جنگ کی پیش رفت دیکھ سکتا ہوں؟",
    "uz": "Vidjetda boshqaning Mashhurlik jangi rivojini ko‘rishim mumkinmi?",
    "vi_VN": "Tôi có thể xem tiến trình PK Điểm Nổi Tiếng của người khác trong tiện ích không?",
    "zh_CN": "除了我自己的对决进度，我还可以在小组件上查看其他人的对决进度吗？"
  },
  "guide_faq_android_content2": {
    "HK": "為甚麼我的小工具人氣值跟遊戲介面不一致？",
    "TW": "為什麼我小工具顯示的人氣值和遊戲內不一致？",
    "ar_SA": "لماذا لا تتطابق الشعبية الظاهرة في عنصر الواجهة الرئيسية مع نظيرتها في اللعبة؟",
    "de_DE": "Wieso stimmt die in meinem Widget angezeigte Beliebtheit nicht mit dem Match überein?",
    "en_US": "Why doesn't the Popularity shown in my widget match the game?",
    "es_ES": "¿Por qué la Popularidad que se muestra en mi widget no se corresponde con la del juego?",
    "fr_FR": "Pourquoi la popularité de mon widget ne correspond-elle pas à celle du jeu ?",
    "hi_IN": "Why doesn't the Popularity shown in my widget match the game?",
    "in_ID": "Mengapa Popularitas yang ditampilkan di widget dan di dalam game berbeda?",
    "ja_JP": "Why doesn't the Popularity shown in my widget match the game?",
    "ko_KR": "Why doesn't the Popularity shown in my widget match the game?",
    "ms_MY": "Mengapakah Populariti yang dipaparkan di widget dan game tidak sepadan?",
    "pt_PT": "Por que a Popularidade exibida no meu widget não corresponde ao jogo?",
    "ru_RU": "Почему уровень популярности на виджете не совпадает с популярностью в игре?",
    "th_TH": "ทำไมความนิยมที่ปรากฏในวิดเจ็ตของฉันจึงไม่ตรงกับเกม?",
    "tr_TR": "Araç takımımda görüntülenen Popülerlik neden oyundaki Popülerlikle eşleşmiyor?",
    "ur": "میرے وجٹ میں دکھائی دینے والی مقبولیت گیم کے ساتھ میچ کیوں نہیں کرتی؟",
    "uz": "Nega vidjetimda ko‘rsatilgan mashhurlik o‘yindagi mashhurlikka mos emas?",
    "vi_VN": "Vì sao Điểm Nổi Tiếng trên widget khác với trong game?",
    "zh_CN": "为什么我的小组件显示的人气值与游戏内不一致？"
  },
  "guide_faq_android_content3": {
    "HK": "新增小元件係咪會消耗手機額外嘅電池同數據流量？",
    "TW": "新增小工具是否會額外消耗手機的電池和數據流量？",
    "ar_SA": "هل تستهلك إضافة عنصر الواجهة قدرًا إضافيًا من شحن البطارية وبيانات الهاتف المحمول؟",
    "de_DE": "Führt das Hinzufügen eines Widgets zu einem erhöhten Energie- oder mobilen Datenverbrauch?",
    "en_US": "Does adding a widget consume additional battery and mobile data?",
    "es_ES": "¿Agregar un widget consume más batería y datos móviles?",
    "fr_FR": "Le fait d'ajouter un widget augmente-t-il la consommation de la batterie et des données mobiles ?",
    "hi_IN": "Does adding a widget consume additional battery and mobile data?",
    "in_ID": "Apakah menambahkan widget akan menyedot daya baterai dan kuota data tambahan?",
    "ja_JP": "Does adding a widget consume additional battery and mobile data?",
    "ko_KR": "Does adding a widget consume additional battery and mobile data?",
    "ms_MY": "Adakah menambahkan widget akan menggunakan bateri tambahan dan data mudah alih?",
    "pt_PT": "Se eu adicionar um widget, gastarei mais bateria e dados móveis?",
    "ru_RU": "Расходуется ли заряд батареи и мобильный трафик при добавлении виджета?",
    "th_TH": "การเพิ่มวิดเจ็ตมีการใช้แบตเตอรี่และดาต้ามือถือเพิ่มเติมหรือไม่?",
    "tr_TR": "Araç takımı eklemek cihazımda fazladan pil veya mobil veri tüketimine neden olur mu?",
    "ur": "کیا وجٹ شامل کرنے سے اضافی بیٹری اور موبائل ڈیٹا استعمال ہوتا ہے؟",
    "uz": "Vidjetni qoʻshish batareya quvvati yoki mobil internet sarf qiladimi?",
    "vi_VN": "Thêm tiện ích có tốn thêm pin và dữ liệu di động không?",
    "zh_CN": "添加小组件是否会消耗手机额外的电池和数据流量？"
  },
  "guide_faq_ios_answer1": {
    "HK": "可以。你可長按小工具，點擊編輯小工具來變更查看對象。目前僅支援查看最近贈送過人氣禮物的玩家。",
    "TW": "可以。長按小工具、點按編輯小工具，再變更查看對象即可。目前僅支援查看最近贈送過人氣禮物的玩家。",
    "ar_SA": "نعم. يمكنك تحديد التقدم الذي ترغب في رؤيته من خلال إعدادات عنصر الواجهة. لا يمكن حاليًا إلا عرض تقدم اللاعبين الذين أرسلوا هدايا الشعبية مؤخرًا.",
    "de_DE": "Ja. In den Widget-Einstellungen kannst du festlegen, wessen Fortschritt angezeigt werden soll. Momentan kannst du nur den Fortschritt von Spielern anzeigen lassen, die dir kürzlich Beliebtheitsgeschenke gesendet haben.",
    "en_US": "Yes. You can change whose progress you'd like to see from the widget settings. Currently, you can only view the progress of players who have recently sent Popularity Gifts.",
    "es_ES": "Sí. En la configuración del widget puedes elegir de qué persona quieres ver el progreso. Actualmente, solo puedes ver el progreso de quienes hayan enviado Regalos de Popularidad recientemente.",
    "fr_FR": "Oui. Vous pouvez choisir le joueur dont vous souhaitez voir la progression dans les paramètres du widget. À l'heure actuelle, seule la progression des joueurs qui ont récemment envoyé des cadeaux de popularité est disponible.",
    "hi_IN": "Yes. You can change whose progress you'd like to see from the widget settings. Currently, you can only view the progress of players who have recently sent Popularity Gifts.",
    "in_ID": "Ya. Kamu bisa memilih progres siapa yang ditampilkan dari pengaturan widget. Saat ini, kamu hanya bisa melihat progres pemain yang baru saja mengirimkan Hadiah Popularitas.",
    "ja_JP": "Yes. You can change whose progress you'd like to see from the widget settings. Currently, you can only view the progress of players who have recently sent Popularity Gifts.",
    "ko_KR": "Yes. You can change whose progress you'd like to see from the widget settings. Currently, you can only view the progress of players who have recently sent Popularity Gifts.",
    "ms_MY": "Ya. Anda boleh memilih kemajuan pemain yang ingin dilihat dalam tetapan widget. Buat masa ini, anda hanya boleh melihat kemajuan pemain yang menghantar Hadiah Populariti baru-baru ini.",
    "pt_PT": "Sim. Você pode escolher de quem ver o progresso nas configurações do widget. No momento, você só pode ver o progresso de jogadores que enviaram Presentes de Popularidade recentemente.",
    "ru_RU": "Да. В настройках виджета можно изменить, чей прогресс вы хотите видеть. В настоящее время вы можете просматривать прогресс только тех игроков, которые недавно отправляли подарки популярности.",
    "th_TH": "แน่นอน คุณสามารถเปลี่ยนความก้าวหน้าของคนที่คุณต้องการดูได้ที่การตั้งค่าวิดเจ็ต ขณะนี้ คุณจะดูได้แค่ความก้าวหน้าของผู้เล่นที่ส่งของขวัญความนิยมในระยะนี้เท่านั้น",
    "tr_TR": "Evet. Araç takımı ayarlarından ilerlemesini görmek istediğin oyuncuları düzenleyebilirsin. Şu anda sadece yakın zamanda Popülerlik hediyeleri gönderen oyuncuların ilerlemesini görebilirsin.",
    "ur": "ہاں۔ آپ وجٹ سیٹنگز میں جا کر یہ تبدیل کر سکتے ہیں کہ آپ کس کی پیش رفت کو دیکھنا چاہیں گے۔ فی الحال، آپ صرف ان پلیئرز کی پیش رفت کو دیکھ سکتے ہیں جنہوں نے حال ہی میں مقبولیت کے گفٹس ارسال کیے ہیں۔",
    "uz": "Ha. Vidjet sozlamalar orqali kimlarning rivojini ko‘rishni o‘zgartirishingiz mumkin. Hozirda faqat yaqinda Mashhurlik hadyalarini yuborgan o‘yinchilar rivojini ko‘ra olasiz.",
    "vi_VN": "Được. Bạn có thể thay đổi tiến trình của ai mà bạn muốn xem từ cài đặt tiện ích. Hiện tại, bạn chỉ có thể xem tiến trình của những người chơi gần đây đã gửi Quà Điểm Nổi Tiếng.",
    "zh_CN": "可以的，可以通过长按小组件，点击编辑小组件，更改查看对象。目前仅支持查看最近赠送过人气礼物的玩家。"
  },
  "guide_faq_ios_answer1_replace_text": {
    "HK": "15",
    "TW": "15",
    "ar_SA": "15",
    "de_DE": "15",
    "en_US": "15",
    "es_ES": "15",
    "fr_FR": "15",
    "hi_IN": "15",
    "in_ID": "15",
    "ja_JP": "15",
    "ko_KR": "15",
    "ms_MY": "15",
    "pt_PT": "15",
    "ru_RU": "15",
    "th_TH": "15",
    "tr_TR": "15",
    "ur": "15",
    "uz": "15",
    "vi_VN": "15",
    "zh_CN": "15"
  },
  "guide_faq_ios_answer2": {
    "HK": "由於系統限制，數據一般會有延遲。但請放心，這不會影響遊戲內人氣禮物相關功能的正常使用。",
    "TW": "由於系統限制，資料通常會有延遲。但請放心，不會影響遊戲內人氣禮物相關功能的正常使用。",
    "ar_SA": "قد يحدث تأخر في تلقي البيانات بسبب قيود النظام. ولكن لا تقلق، فهذا لن يؤثر على استخدام هدايا الشعبية داخل اللعبة.",
    "de_DE": "Aufgrund von Systembeschränkungen kann es zu einer Verzögerung bei den Daten kommen. Keine Sorge, die Beliebtheitsgeschenke im Spiel sind davon natürlich nicht betroffen.",
    "en_US": "Due to system limitations, there may be a delay in the data. However, rest assured that this does not affect the use of Popularity Gifts in-game.",
    "es_ES": "Debido a limitaciones del sistema, puede haber demora en los datos. Sin embargo, esto no afectará el uso de los Regalos de Popularidad en el juego.",
    "fr_FR": "En raison des limitations du système, le traitement des données peut être retardé. Cependant, l'utilisation des cadeaux de popularité dans le jeu n'en sera pas affectée.",
    "hi_IN": "Due to system limitations, there may be a delay in the data. However, rest assured that this does not affect the use of Popularity Gifts in-game.",
    "in_ID": "Akibat adanya batasan sistem, keterlambatan data bisa saja terjadi. Jangan khawatir, keterlambatan ini tidak akan memengaruhi penggunaan Hadiah Popularitas dalam game.",
    "ja_JP": "Due to system limitations, there may be a delay in the data. However, rest assured that this does not affect the use of Popularity Gifts in-game.",
    "ko_KR": "Due to system limitations, there may be a delay in the data. However, rest assured that this does not affect the use of Popularity Gifts in-game.",
    "ms_MY": "Kelewatan data mungkin berlaku disebabkan had sistem. Namun begitu, ini tidak akan menjejaskan penggunaan Hadiah Populariti dalam game.",
    "pt_PT": "Devido a limitações do sistema, pode haver um atraso nos dados. Isso não afeta o uso de Presentes de Popularidade no jogo.",
    "ru_RU": "В связи с ограничениями системы возможна задержка при получении данных. Однако это не повлияет на использование подарков популярности в игре.",
    "th_TH": "จากข้อจำกัดด้านระบบ ส่งผลให้ข้อมูลอาจมีความล่าช้าอยู่บ้าง อย่างไรก็ตาม สามารถวางใจได้ว่าสิ่งนี้จะไม่ส่งผลต่อการใช้งานฟีเจอร์ของขวัญความนิยมภายในเกม",
    "tr_TR": "Sistem kısıtlamalarından dolayı verilerin güncellenmesinde gecikme meydana gelebilir. Ancak bu durum, oyunda Popülerlik hediyelerinin kullanımını etkilemez.",
    "ur": "سسٹم کی حدود کی وجہ سے، ڈیٹا میں تاخیر ہو سکتی ہے۔ تاہم، بے فکر رہیں کیونکہ یہ ان-گیم مقبولیت کے گفٹس کے استعمال پر اثر انداز نہیں ہوتا۔",
    "uz": "Tizim cheklovlari sababli ma’lumotlarda kechikish bo‘lishi mumkin. Lekin xotirjam bo‘ling, bu o‘yin ichida Mashhurlik hadyalaridan foydalanishda ta’sir qilmaydi.",
    "vi_VN": "Do hạn chế của hệ thống, dữ liệu có thể bị chậm trễ. Tuy nhiên, hãy yên tâm rằng điều này không ảnh hưởng đến việc sử dụng Quà Điểm Nổi Tiếng biến trong trò chơi.",
    "zh_CN": "因为系统限制，数据一般会有延迟。但请放心，不会影响游戏内人气礼物相关功能的正常使用。"
  },
  "guide_faq_ios_answer3": {
    "HK": "唔會，小元件只喺螢幕亮起時以15分鐘嘅頻率更新。",
    "TW": "不會，小工具只在螢幕亮起時以15分鐘1次的頻率重新整理。",
    "ar_SA": "لا، إذ لا تُحدَّث بيانات عنصر الواجهة إلا كل %s دقيقة عندما تكون الشاشة قيد التشغيل.",
    "de_DE": "Nein, das Widget aktualisiert die Daten nur alle 15 Minuten, wenn der Bildschirm aktiviert ist.",
    "en_US": "Nope, the widget only refreshes data every 15 minutes when the screen is on.",
    "es_ES": "¡Para nada! El widget solo actualiza la información cada 15 minutos cuando la pantalla está encendida.",
    "fr_FR": "Non, le widget n'actualise les données qu'une fois toutes les 15 minutes lorsque l'écran est allumé.",
    "hi_IN": "Nope, the widget only refreshes data every 15 minutes when the screen is on.",
    "in_ID": "Tidak. Widget hanya memperbarui data setiap 15 menit sekali saat layar dalam keadaan menyala.",
    "ja_JP": "Nope, the widget only refreshes data every 15 minutes when the screen is on.",
    "ko_KR": "Nope, the widget only refreshes data every 15 minutes when the screen is on.",
    "ms_MY": "Tidak, widget hanya menyegar semula data setiap 15 minit apabila skrin dihidupkan.",
    "pt_PT": "Não, o widget só é atualizado a cada 15 minutos quando a tela está ligada.",
    "ru_RU": "Нет, виджет обновляет данные только раз в 15 минут, когда экран включен.",
    "th_TH": "ไม่ใช้ โดยวิดเจ็ตจะรีเฟรชข้อมูลทุกๆ 15 นาที เมื่อหน้าจอเปิดอยู่เท่านั้น",
    "tr_TR": "Hayır, cihaz ekranın açıkken sadece 15 dakikada bir veri yeniler.",
    "ur": "نہیں، اسکرین آن ہونے پر وجٹ پر صرف ہر %s منٹ میں ڈیٹا ریفریش ہوتا ہے۔",
    "uz": "Yoʻq, bu vidjet faqat ekran yoniq vaqtda maʼlumotlarni har 15 daqiqada yangilaydi.",
    "vi_VN": "Không, tiện ích chỉ làm mới dữ liệu 15 phút một lần khi màn hình bật.",
    "zh_CN": "不会，小组件只在屏幕亮起时以15分钟的频率刷新。"
  },
  "guide_faq_ios_answer3_replace_text": {
    "HK": "15",
    "TW": "15",
    "ar_SA": "15",
    "de_DE": "15",
    "en_US": "15",
    "es_ES": "15",
    "fr_FR": "15",
    "hi_IN": "15",
    "in_ID": "15",
    "ja_JP": "15",
    "ko_KR": "15",
    "ms_MY": "15",
    "pt_PT": "15",
    "ru_RU": "15",
    "th_TH": "15",
    "tr_TR": "15",
    "ur": "15",
    "uz": "15",
    "vi_VN": "15",
    "zh_CN": "15"
  },
  "guide_faq_ios_content1": {
    "HK": "除了自己的對決進度，我還可在小工具上查看其他對決進度嗎？",
    "TW": "除了自己的對決進度，我也可以在小工具上查看其他的對決進度嗎？",
    "ar_SA": "هل يمكنني رؤية تقدم لاعب آخر في معركة الشعبية من خلال عنصر الواجهة؟",
    "de_DE": "Kann ich den Beliebtheitskampf-Fortschritt anderer Spieler im Widget sehen?",
    "en_US": "Can I view someone else's Popularity Battle progress in the widget?",
    "es_ES": "¿Puedo ver el progreso de la Batalla de Popularidad de alguien más en el widget?",
    "fr_FR": "Puis-je voir la progression des Combats de popularité d'un autre joueur dans le widget ?",
    "hi_IN": "Can I view someone else's Popularity Battle progress in the widget?",
    "in_ID": "Apakah saya bisa melihat progres Popularity Battle pemain lain dari widget?",
    "ja_JP": "Can I view someone else's Popularity Battle progress in the widget?",
    "ko_KR": "Can I view someone else's Popularity Battle progress in the widget?",
    "ms_MY": "Bolehkah saya melihat Pertempuran Populariti pemain lain di widget?",
    "pt_PT": "Posso ver o progresso de Batalha de Popularidade de outro jogador no widget?",
    "ru_RU": "Могу ли я посмотреть на виджете прогресс битвы популярности другого игрока?",
    "th_TH": "ฉันสามารถดูความก้าวหน้าการท้าดวลความนิยมของผู้อื่นผ่านทางวิดเจ็ตได้หรือไม่?",
    "tr_TR": "Araç takımından başka bir oyuncunun Popülerlik Savaşı ilerlemesini görebilir miyim?",
    "ur": "کیا میں وجٹ میں کسی اور کی مقبولیت کی جنگ کی پیش رفت دیکھ سکتا ہوں؟",
    "uz": "Vidjetda boshqaning Mashhurlik jangi rivojini ko‘rishim mumkinmi?",
    "vi_VN": "Tôi có thể xem tiến trình PK Điểm Nổi Tiếng của người khác trong tiện ích không?",
    "zh_CN": "除了我自己的对决进度，我还可以在小组件上查看其他人的对决进度吗？"
  },
  "guide_faq_ios_content2": {
    "HK": "為甚麼我的小工具人氣值跟遊戲介面不一致？",
    "TW": "為什麼我小工具顯示的人氣值和遊戲內不一致？",
    "ar_SA": "لماذا لا تتطابق الشعبية الظاهرة في عنصر الواجهة الرئيسية مع نظيرتها في اللعبة؟",
    "de_DE": "Wieso stimmt die in meinem Widget angezeigte Beliebtheit nicht mit dem Match überein?",
    "en_US": "Why doesn't the Popularity shown in my widget match the game?",
    "es_ES": "¿Por qué la Popularidad que se muestra en mi widget no se corresponde con la del juego?",
    "fr_FR": "Pourquoi la popularité de mon widget ne correspond-elle pas à celle du jeu ?",
    "hi_IN": "Why doesn't the Popularity shown in my widget match the game?",
    "in_ID": "Mengapa Popularitas yang ditampilkan di widget dan di dalam game berbeda?",
    "ja_JP": "Why doesn't the Popularity shown in my widget match the game?",
    "ko_KR": "Why doesn't the Popularity shown in my widget match the game?",
    "ms_MY": "Mengapakah Populariti yang dipaparkan di widget dan game tidak sepadan?",
    "pt_PT": "Por que a Popularidade exibida no meu widget não corresponde ao jogo?",
    "ru_RU": "Почему уровень популярности на виджете не совпадает с популярностью в игре?",
    "th_TH": "ทำไมความนิยมที่ปรากฏในวิดเจ็ตของฉันจึงไม่ตรงกับเกม?",
    "tr_TR": "Araç takımımda görüntülenen Popülerlik neden oyundaki Popülerlikle eşleşmiyor?",
    "ur": "میرے وجٹ میں دکھائی دینے والی مقبولیت گیم کے ساتھ میچ کیوں نہیں کرتی؟",
    "uz": "Nega vidjetimda ko‘rsatilgan mashhurlik o‘yindagi mashhurlikka mos emas?",
    "vi_VN": "Vì sao Điểm Nổi Tiếng trên widget khác với trong game?",
    "zh_CN": "为什么我的小组件显示的人气值与游戏内不一致？"
  },
  "guide_faq_ios_content3": {
    "HK": "使用小元件係咪會消耗手機額外嘅電池同數據流量？",
    "TW": "使用小工具是否會額外消耗手機的電池和數據流量？",
    "ar_SA": "هل يستهلك عنصر الواجهة قدرًا إضافيًا من شحن البطارية وبيانات الهاتف المحمول؟",
    "de_DE": "Führt die Verwendung des Widgets zu einem erhöhten Energie- oder mobilen Datenverbrauch?",
    "en_US": "Does the widget consume additional battery and mobile data?",
    "es_ES": "¿Consume el widget más batería y datos móviles?",
    "fr_FR": "Le widget consomme-t-il davantage la batterie et les données mobiles ?",
    "hi_IN": "Does the widget consume additional battery and mobile data?",
    "in_ID": "Apakah widget menyedot daya baterai dan kuota data tambahan?",
    "ja_JP": "Does the widget consume additional battery and mobile data?",
    "ko_KR": "Does the widget consume additional battery and mobile data?",
    "ms_MY": "Adakah widget menggunakan bateri tambahan dan data mudah alih?",
    "pt_PT": "O widget consome bateria e dados móveis adicionais?",
    "ru_RU": "Потребляет ли виджет больше заряда батареи и мобильного трафика?",
    "th_TH": "วิดเจ็ตมีการใช้แบตเตอรี่และดาต้ามือถือเพิ่มเติมหรือไม่?",
    "tr_TR": "Araç takımı cihazımda fazladan pil veya mobil veri tüketimine neden olur mu?",
    "ur": "کیا وجٹ اضافی بیٹری اور موبائل ڈیٹا استعمال کرتا ہے؟",
    "uz": "Bu vidjet qoʻshimcha batareya quvvati yoki mobil internet sarf qiladimi?",
    "vi_VN": "Tiện ích này có tốn thêm pin và dữ liệu di động không?",
    "zh_CN": "使用小组件是否会消耗手机额外的电池和数据流量？"
  },
  "guide_faq_question": {
    "HK": "問題：",
    "TW": "問題：",
    "ar_SA": "سؤال:  ",
    "de_DE": "F:  ",
    "en_US": "Q:  ",
    "es_ES": "P:  ",
    "fr_FR": "Q :  ",
    "hi_IN": "Q:  ",
    "in_ID": "T:  ",
    "ja_JP": "Q:  ",
    "ko_KR": "Q:  ",
    "ms_MY": "S:  ",
    "pt_PT": "P:  ",
    "ru_RU": "В:  ",
    "th_TH": "คำถาม:  ",
    "tr_TR": "S:  ",
    "ur": "سوال:",
    "uz": "S.    ",
    "vi_VN": "Câu hỏi:  ",
    "zh_CN": "问题："
  },
  "guide_faq_title": {
    "HK": "常見問題",
    "TW": "常見問題",
    "ar_SA": "أسئلة شائعة",
    "de_DE": "FAQ",
    "en_US": "FAQ",
    "es_ES": "Preguntas frecuentes",
    "fr_FR": "FAQ",
    "hi_IN": "FAQ",
    "in_ID": "Tanya-Jawab Umum",
    "ja_JP": "FAQ",
    "ko_KR": "FAQ",
    "ms_MY": "Soalan Lazim",
    "pt_PT": "Perguntas Frequentes",
    "ru_RU": "Вопросы и ответы",
    "th_TH": "คำถามที่พบบ่อย",
    "tr_TR": "SSS",
    "ur": "اکثر پوچھا جانے والا سوال",
    "uz": "SAVOL-JAVOBLAR",
    "vi_VN": "Câu Hỏi Thường Gặp",
    "zh_CN": "常见问题"
  },
  "guide_feedback_btn": {
    "HK": "反饋",
    "TW": "回報",
    "ar_SA": "الملاحظات",
    "de_DE": "Feedback",
    "en_US": "Feedback",
    "es_ES": "Comentarios",
    "fr_FR": "Commentaire",
    "hi_IN": "Feedback",
    "in_ID": "Tanggapan",
    "ja_JP": "Feedback",
    "ko_KR": "Feedback",
    "ms_MY": "Maklum Balas",
    "pt_PT": "Feedback",
    "ru_RU": "Отзывы",
    "th_TH": "ฟีดแบค",
    "tr_TR": "Geri Bildirim",
    "ur": "‏رائے",
    "uz": "Fikr-mulohaza",
    "vi_VN": "Phản Hồi",
    "zh_CN": "反馈"
  },
  "guide_feedback_tips": {
    "HK": "如有其他問題，請點擊呢度提交：",
    "TW": "若有其他問題，請點按這裡提出：",
    "ar_SA": "إذا كانت لديك أي أسئلة أخرى، فاضغط هنا لإرسالها: ",
    "de_DE": "Falls du weitere Fragen hast, kannst du hier tippen, um sie an uns zu schicken: ",
    "en_US": "If you have any other questions, tap here to submit them: ",
    "es_ES": "Si tienen alguna otra pregunta, toca aquí para enviarla: ",
    "fr_FR": "Si vous avez d'autres questions à poser, appuyez ici pour les envoyer : ",
    "hi_IN": "If you have any other questions, tap here to submit them: ",
    "in_ID": "Jika kamu memiliki pertanyaan lain, tekan kolom ini dan sampaikan pertanyaanmu: ",
    "ja_JP": "If you have any other questions, tap here to submit them: ",
    "ko_KR": "If you have any other questions, tap here to submit them: ",
    "ms_MY": "Jika anda mempunyai sebarang pertanyaan lain, ketik di sini untuk menyerahkannya: ",
    "pt_PT": "Se tiver alguma outra dúvida, toque aqui para enviá-la: ",
    "ru_RU": "Если у вас остались вопросы, нажмите здесь, чтобы задать их: ",
    "th_TH": "หากคุณมีคำถามอื่นๆ เพิ่มเติม สามารถแตะที่นี่เพื่อส่งคำถามได้: ",
    "tr_TR": "Farklı soruların olursa buraya dokunarak bize iletebilirsin: ",
    "ur": "اگر آپ کے کوئی دوسرے سوالات ہیں، تو انہیں جمع کروانے کے لیے یہاں ٹیپ کریں:",
    "uz": "Boshqa savollaringiz boʻlsa, ularni yuborish uchun bu yerga bosing: ",
    "vi_VN": "Nếu có bất kỳ câu hỏi nào khác, hãy nhấn vào đây để gửi chúng: ",
    "zh_CN": "如有其他问题，请点击这里提交："
  },
  "guide_how_android_content1": {
    "HK": "用兩隻手指喺主螢幕上捏合，然後點擊「元件」。",
    "TW": "在主畫面上用兩指捏合，然後點按「小工具」。",
    "ar_SA": "اضغط بإصبعيك على الشاشة الرئيسية لجهازك لدخول وضع التحرير، ثم اضغط على \"عناصر الواجهة\".",
    "de_DE": "Öffne im Startbildschirm deines Geräts durch das Zusammenziehen deiner Finger den Bearbeitungsmodus und tippe auf „Widgets“.",
    "en_US": "On your device's home screen, pinch to enter edit mode, then tap \"Widgets\".",
    "es_ES": "En la pantalla de inicio de tu dispositivo, toca para acceder al modo edición y luego toca en \"Widgets\".",
    "fr_FR": "Sur l'écran d'accueil de votre appareil, pincez pour accéder au mode édition, puis appuyez sur \"Widgets\".",
    "hi_IN": "On your device's home screen, pinch to enter edit mode, then tap \"Widgets\".",
    "in_ID": "Jepit kedua jari di layar beranda ponsel untuk masuk ke mode edit, lalu tekan \"Widget\".",
    "ja_JP": "On your device's home screen, pinch to enter edit mode, then tap \"Widgets\".",
    "ko_KR": "On your device's home screen, pinch to enter edit mode, then tap \"Widgets\".",
    "ms_MY": "Pada skrin utama peranti anda, cubit untuk memasuki mod pengeditan, kemudian ketik \"Widget\".",
    "pt_PT": "Na tela inicial do seu dispositivo, junte os dedos para entrar no modo de edição, depois toque em \"Widgets\".",
    "ru_RU": "Жестом сжатия на рабочем столе своего устройства перейдите в режим редактирования, а затем нажмите «Виджеты».",
    "th_TH": "ที่หน้าโฮมของอุปกรณ์ บีบนิ้วเข้าหากันเพื่อเข้าสู่โหมดปรับแต่ง จากนั้น แตะ \"วิดเจ็ต\"",
    "tr_TR": "Cihazının ana ekranında düzenleme moduna gir ve araç takımlarına (\"Widgets\") dokun.",
    "ur": "اپنی ڈیوائس کی ہوم اسکرین پر، ترمیمی موڈ میں داخل ہونے کے لیے آہستہ سے دبائیں، پھر \"وجٹس\" پر ٹیپ کریں۔",
    "uz": "Qurilmangiz asosiy ekranida tahrirlash rejimiga kirish uchun chimding, keyin Vidjetlar tugmasini bosing.",
    "vi_VN": "Trên màn hình chính thiết bị của bạn, chụm hai ngón tay lại để vào chế độ chỉnh sửa, sau đó nhấn \"Tiện Ích\".",
    "zh_CN": "用两根手指在主屏幕上捏合，然后点击“组件”。"
  },
  "guide_how_android_content2": {
    "HK": "搜尋「PUBG MOBILE」（如果有彈出窗口），然後點擊佢。",
    "TW": "搜尋「PUBG MOBILE」（若有彈出視窗），然後點按它。",
    "ar_SA": "ابحث عن \"%s\" (في النافذة المنبثقة، إن انطبق ذلك) واضغط عليها.",
    "de_DE": "Suche nach „PUBG MOBILE“ (ggf. im Pop-up-Fenster) und tippe darauf.",
    "en_US": "Search \"PUBG MOBILE\" (in the pop-up window, if applicable) and tap it.",
    "es_ES": "Busca \"PUBG MOBILE\" (en la pantalla emergente, si fuera el caso) y tócalo.",
    "fr_FR": "Recherchez \"PUBG MOBILE\" dans la liste (ou via le pop-up, le cas échéant) et appuyez dessus.",
    "hi_IN": "Search \"PUBG MOBILE\" (in the pop-up window, if applicable) and tap it.",
    "in_ID": "Cari \"PUBG MOBILE\" (di jendela pop-up, jika ada) lalu pilih.",
    "ja_JP": "Search \"PUBG MOBILE\" (in the pop-up window, if applicable) and tap it.",
    "ko_KR": "Search \"PUBG MOBILE\" (in the pop-up window, if applicable) and tap it.",
    "ms_MY": "Cari \"PUBG MOBILE\" (dalam tetingkap pop timbul, jika berkenaan) dan ketiknya.",
    "pt_PT": "Procure \"PUBG MOBILE\" (na janela que aparecer, caso apareça) e toque nele.",
    "ru_RU": "Найдите «PUBG MOBILE» (во всплывающем окне, если оно появится) и нажмите на него.",
    "th_TH": "ค้นหา \"PUBG MOBILE\" (ถ้ามีหน้าต่างป๊อปอัป) และแตะ",
    "tr_TR": "\"PUBG MOBILE\"ı ara (varsa açılan pencerede) ve ona dokun.",
    "ur": "‏\"%s\" تلاش کریں (اگر قابلِ اطلاق ہو، تو پاپ اپ ونڈو میں) اور اس پر ٹیپ کریں۔",
    "uz": "PUBG MOBILE deb qidiring (qalqib chiquvchi oynada, agar mavjud boʻlsa) va uning ustiga bosing.",
    "vi_VN": "Tìm kiếm \"PUBG MOBILE\" (trong cửa sổ hiện ra, nếu có) và nhấn vào.",
    "zh_CN": "搜索“PUBG MOBILE” （如果有弹出窗口），然后点击它。"
  },
  "guide_how_android_content2_replace_text": {
    "HK": "PUBG MOBILE",
    "TW": "PUBG MOBILE",
    "ar_SA": "PUBG MOBILE",
    "de_DE": "PUBG MOBILE",
    "en_US": "PUBG MOBILE",
    "es_ES": "PUBG MOBILE",
    "fr_FR": "PUBG MOBILE",
    "hi_IN": "PUBG MOBILE",
    "in_ID": "PUBG MOBILE",
    "ja_JP": "PUBG MOBILE",
    "ko_KR": "PUBG MOBILE",
    "ms_MY": "PUBG MOBILE",
    "pt_PT": "PUBG MOBILE",
    "ru_RU": "PUBG MOBILE",
    "th_TH": "PUBG MOBILE",
    "tr_TR": "PUBG MOBILE",
    "ur": "PUBG MOBILE",
    "uz": "PUBG MOBILE",
    "vi_VN": "PUBG MOBILE",
    "zh_CN": "PUBG MOBILE"
  },
  "guide_how_android_content3": {
    "HK": "選擇你想要嘅元件尺寸，然後將元件拖曳到主螢幕。",
    "TW": "選擇想要的小工具尺寸，然後將小工具拖曳到主畫面。",
    "ar_SA": "حدد الحجم المُراد لعنصر الواجهة، ثم اسحبه لإضافته إلى الشاشة الرئيسية لجهازك.",
    "de_DE": "Wähle die gewünschte Widgetgröße und ziehe das Widget dann, um es dem Startbildschirm deines Geräts hinzuzufügen.",
    "en_US": "Select the widget size you want, then drag the widget to add it to your device's home screen.",
    "es_ES": "Selecciona el tamaño del widget que quieras y luego arrástralo hasta la pantalla de inicio de tu dispositivo.",
    "fr_FR": "Choisissez la taille désirée, puis faites glisser le widget pour l'ajouter à l'écran d'accueil de votre appareil.",
    "hi_IN": "Select the widget size you want, then drag the widget to add it to your device's home screen.",
    "in_ID": "Pilih ukuran widget yang kamu inginkan, lalu seret widget untuk menambahkannya ke beranda.",
    "ja_JP": "Select the widget size you want, then drag the widget to add it to your device's home screen.",
    "ko_KR": "Select the widget size you want, then drag the widget to add it to your device's home screen.",
    "ms_MY": "Pilih saiz widget yang anda ingini, kemudian seret widget untuk menambahkannya pada skrin utama peranti anda.",
    "pt_PT": "Escolha o tamanho de widget desejado, depois arraste-o para adicioná-lo à tela inicial.",
    "ru_RU": "Выберите нужный размер виджета, затем перетащите его на рабочий стол вашего устройства.",
    "th_TH": "เลือกขนาดวิดเจ็ตที่คุณต้องการ จากนั้น ลากวิดเจ็ตเพื่อเพิ่มลงในหน้าโฮมของอุปกรณ์ของคุณ",
    "tr_TR": "Dilediğin araç takımı boyutunu seç ve cihazının ana ekranına eklemek için araç takımını sürükle.",
    "ur": "اپنا من پسند وجٹ سائز منتخب کریں، پھر اپنی ڈیوائس کی ہوم اسکرین پر وجٹ شامل کرنے کے لیے اسے گھسیٹیں۔",
    "uz": "Kerakli vidjet oʻlchamini tanlab, vidjetni asosiy ekranga qoʻshish uchun uni ushlab torting.",
    "vi_VN": "Chọn kích thước tiện ích bạn muốn, sau đó kéo tiện ích để thêm vào màn hình chính của thiết bị.",
    "zh_CN": "选择您想要的组件尺寸，然后将组件拖动到主屏幕。"
  },
  "guide_how_android_title": {
    "HK": "如何增加元件？（唔同機型可能有唔同嘅程序）",
    "TW": "如何新增小工具？（不同機型流程可能不同）",
    "ar_SA": "كيفية إضافة عناصر الواجهة (قد تختلف الخطوات من جهاز لآخر)",
    "de_DE": "So fügst du ein Widget hinzu (je nach Gerätetyp können die Schritte variieren)",
    "en_US": "How to Add a Widget (Steps may vary between devices)",
    "es_ES": "Cómo añadir un widget (los pasos pueden variar entre dispositivos)",
    "fr_FR": "Ajouter un widget (la procédure peut varier d'un appareil à l'autre)",
    "hi_IN": "How to Add a Widget (Steps may vary between devices)",
    "in_ID": "Cara Menambahkan Widget (Cara bisa saja berbeda pada perangkat yang berbeda)",
    "ja_JP": "How to Add a Widget (Steps may vary between devices)",
    "ko_KR": "How to Add a Widget (Steps may vary between devices)",
    "ms_MY": "Cara untuk Menambahkan Widget (Langkah-langkah mungkin berbeza, bergantung pada peranti)",
    "pt_PT": "Como Adicionar um Widget (os passos podem variar entre dispositivos)",
    "ru_RU": "Как добавить виджет (шаги могут отличаться на разных устройствах)",
    "th_TH": "วิธีการเพิ่มวิดเจ็ต (ขั้นตอนอาจแตกต่างกันไปตามอุปกรณ์)",
    "tr_TR": "Araç Takımı Nasıl Eklenir (Adımlar cihaza göre değişebilir)",
    "ur": "وجٹ شامل کرنے کا طریقہ کار (ڈیوائسز کے لحاظ سے مراحل مختلف ہو سکتے ہیں!",
    "uz": "Vidjetni qanday qoʻshish mumkin (qurilmaga qarab, qadamlar farq qilishi mumkin)",
    "vi_VN": "Cách để thêm tiện ích (Quy trình có thể khác nhau giữa các thiết bị)",
    "zh_CN": "如何添加组件（不同机型可能有不同的流程）"
  },
  "guide_how_ios_content1": {
    "HK": "長撳主螢幕1秒，然後點擊左上角嘅「+」按鈕。",
    "TW": "長按主畫面1秒，然後點按左上角的「+」按鈕。",
    "ar_SA": "اضغط واستمر في الضغط على الشاشة الرئيسية، ثم اضغط على زر \"+\" في الركن العلوي الأيسر.",
    "de_DE": "Tippe und halte auf dem Startbildschirm gedrückt, tippe dann auf den „+“-Button oben links.",
    "en_US": "Tap and hold on the Home Screen, then tap the \"+\" button in the top left corner.",
    "es_ES": "En la pantalla de inicio, toca y mantén presionado hasta ver el botón \"+\" en la esquina superior izquierda. Tócalo.",
    "fr_FR": "Appuyez de manière prolongée sur l'écran d'accueil, puis appuyez sur le bouton \"+\" dans le coin supérieur gauche.",
    "hi_IN": "Tap and hold on the Home Screen, then tap the \"+\" button in the top left corner.",
    "in_ID": "Tekan dan tahan pada Layar Utama, lalu tekan tombol \"+\" di pojok kiri atas.",
    "ja_JP": "Tap and hold on the Home Screen, then tap the \"+\" button in the top left corner.",
    "ko_KR": "Tap and hold on the Home Screen, then tap the \"+\" button in the top left corner.",
    "ms_MY": "Ketik dan tahan pada Skrin Utama, kemudian ketik butang \"+\" di penjuru kiri bahagian atas.",
    "pt_PT": "Toque e segure na Tela de Início, depois toque no botão \"+\" no canto superior esquerdo.",
    "ru_RU": "Длительным нажатием на рабочий стол перейдите в режим редактирования, затем нажмите на «+» в левом верхнем углу.",
    "th_TH": "แตะค้างที่หน้าโฮม จากนั้น แตะปุ่ม \"+\" บริเวณมุมบนซ้าย",
    "tr_TR": "Ana ekrana dokunarak basılı tut, ardından sol üst köşede beliren \"+\" butonuna dokun.",
    "ur": "ہوم اسکرین پر ٹیپ کریں اور ہولڈ کریں، پھر اوپر بائیں کونے میں موجود \"+\" بٹن پر ٹیپ کریں۔",
    "uz": "Asosiy ekranga bosib turing, keyin yuqori chap burchakdagi + belgisiga tegining.",
    "vi_VN": "Nhấn giữ trên Màn Hình Chính, nhấn dấu \"+\" ở góc trên bên trái.",
    "zh_CN": "长按主屏幕1秒，然后点击左上角的“+”按钮。"
  },
  "guide_how_ios_content2": {
    "HK": "喺搜索框中搜尋「PUBG MOBILE」。",
    "TW": "在搜尋欄中搜尋「PUBG MOBILE」。",
    "ar_SA": "اكتب \"%s\" في شريط البحث.",
    "de_DE": "Gib in der Suchleiste „PUBG MOBILE“ ein.",
    "en_US": "Type \"PUBG MOBILE\" in the search bar.",
    "es_ES": "Escribe \"PUBG MOBILE\" en la barra de búsqueda.",
    "fr_FR": "Saisissez \"PUBG MOBILE\" dans la barre de recherche.",
    "hi_IN": "Type \"PUBG MOBILE\" in the search bar.",
    "in_ID": "Ketik \"PUBG MOBILE\" di bilah pencarian.",
    "ja_JP": "Type \"PUBG MOBILE\" in the search bar.",
    "ko_KR": "Type \"PUBG MOBILE\" in the search bar.",
    "ms_MY": "Taipkan \"PUBG MOBILE\" dalam bar carian.",
    "pt_PT": "Digite \"PUBG MOBILE\" na barra de pesquisa.",
    "ru_RU": "Введите в строку поиска «PUBG MOBILE».",
    "th_TH": "พิมพ์ \"PUBG MOBILE\" ในแถบค้นหา",
    "tr_TR": "Arama çubuğuna \"PUBG MOBILE\" yaz.",
    "ur": "تلاش کے بار میں \"%s\" ٹائپ کریں۔",
    "uz": "Qidiruv satriga PUBG MOBILE deb yozing.",
    "vi_VN": "Gõ \"PUBG MOBILE\" trong thanh tìm kiếm.",
    "zh_CN": "在搜索框中搜索“PUBG MOBILE” 。"
  },
  "guide_how_ios_content2_replace_text": {
    "HK": "PUBG MOBILE",
    "TW": "PUBG MOBILE",
    "ar_SA": "PUBG MOBILE",
    "de_DE": "PUBG MOBILE",
    "en_US": "PUBG MOBILE",
    "es_ES": "PUBG MOBILE",
    "fr_FR": "PUBG MOBILE",
    "hi_IN": "PUBG MOBILE",
    "in_ID": "PUBG MOBILE",
    "ja_JP": "PUBG MOBILE",
    "ko_KR": "PUBG MOBILE",
    "ms_MY": "PUBG MOBILE",
    "pt_PT": "PUBG MOBILE",
    "ru_RU": "PUBG MOBILE",
    "th_TH": "PUBG MOBILE",
    "tr_TR": "PUBG MOBILE",
    "ur": "PUBG MOBILE",
    "uz": "PUBG MOBILE",
    "vi_VN": "PUBG MOBILE",
    "zh_CN": "PUBG MOBILE"
  },
  "guide_how_ios_content3": {
    "HK": "選擇你想要嘅元件尺寸，然後點擊「增加元件」。",
    "TW": "選擇您想要的小工具尺寸，然後點按「加入小工具」。",
    "ar_SA": "حدد حجم عنصر الواجهة الذي ترغب فيه، ثم اضغط على \"إضافة عنصر الواجهة\".",
    "de_DE": "Wähle die gewünschte Widgetgröße und tippe auf „Widget hinzufügen“.",
    "en_US": "Select the widget size you want, then tap \"Add Widget\".",
    "es_ES": "Selecciona el tamaño del widget que quieras y luego toca en \"Añadir widget\".",
    "fr_FR": "Choisissez la taille désirée, puis appuyez sur \"Ajouter le widget\".",
    "hi_IN": "Select the widget size you want, then tap \"Add Widget\".",
    "in_ID": "Pilih ukuran widget yang kamu inginkan, lalu tekan \"Tambah Widget\".",
    "ja_JP": "Select the widget size you want, then tap \"Add Widget\".",
    "ko_KR": "Select the widget size you want, then tap \"Add Widget\".",
    "ms_MY": "Pilih saiz widget yang anda ingini, kemudian ketik \"Tambah Widget\".",
    "pt_PT": "Selecione o tamanho de widget desejado e toque em \"Adicionar Widget\".",
    "ru_RU": "Выберите нужный размер виджета, затем нажмите «Добавить виджет».",
    "th_TH": "เลือกขนาดวิดเจ็ตที่คุณต้องการ จากนั้น แตะ \"เพิ่มวิดเจ็ต\"",
    "tr_TR": "Dilediğin araç takımı boyutunu seç ve \"Araç Takımı Ekle\"ye dokun.",
    "ur": "اپنا من پسند وجٹ سائز منتخب کریں، پھر \"وجٹ شامل کریں\" پر ٹیپ کریں۔",
    "uz": "Kerakli vidjet oʻlchamini tanlab, Vidjetni qoʻshish tugmasini bosing.",
    "vi_VN": "Chọn kích thước mong muốn rồi nhấn \"Thêm Tiện Ích\".",
    "zh_CN": "选择您想要的组件尺寸，然后点击“添加组件”。"
  },
  "guide_how_ios_title": {
    "HK": "如何增加元件？",
    "TW": "如何新增小工具？",
    "ar_SA": "كيفية إضافة عناصر الواجهة",
    "de_DE": "So fügst du ein Widget hinzu",
    "en_US": "How to Add a Widget",
    "es_ES": "Cómo añadir un widget",
    "fr_FR": "Ajouter un widget",
    "hi_IN": "How to Add a Widget",
    "in_ID": "Cara Menambahkan Widget",
    "ja_JP": "How to Add a Widget",
    "ko_KR": "How to Add a Widget",
    "ms_MY": "Cara Menambahkan Widget",
    "pt_PT": "Como Adicionar um Widget",
    "ru_RU": "Как добавить виджет",
    "th_TH": "วิธีการเพิ่มวิดเจ็ต",
    "tr_TR": "Araç Takımı Nasıl Eklenir",
    "ur": "وجٹ شامل کرنے کا طریقہ کار",
    "uz": "Vidjetni qanday qoʻshish mumkin",
    "vi_VN": "Cách Thêm Tiện Ích",
    "zh_CN": "如何添加组件"
  },
  "guide_how_step1": {
    "HK": "步驟一：",
    "TW": "步驟一：",
    "ar_SA": "الخطوة 1:  ",
    "de_DE": "Schritt 1:  ",
    "en_US": "Step1:  ",
    "es_ES": "Paso 1:  ",
    "fr_FR": "Étape 1 :  ",
    "hi_IN": "Step1:  ",
    "in_ID": "Langkah 1:  ",
    "ja_JP": "Step1:  ",
    "ko_KR": "Step1:  ",
    "ms_MY": "Langkah 1:  ",
    "pt_PT": "Etapa 1:  ",
    "ru_RU": "Шаг 1:  ",
    "th_TH": "ขั้นตอนที่ 1:  ",
    "tr_TR": "1. Adım:  ",
    "ur": "مرحلہ 1:",
    "uz": "1-qadam:    ",
    "vi_VN": "Bước 1:  ",
    "zh_CN": "步骤1："
  },
  "guide_how_step2": {
    "HK": "步驟二：",
    "TW": "步驟二：",
    "ar_SA": "الخطوة 2:  ",
    "de_DE": "Schritt 2:  ",
    "en_US": "Step2:  ",
    "es_ES": "Paso 2:  ",
    "fr_FR": "Étape 2 :  ",
    "hi_IN": "Step2:  ",
    "in_ID": "Langkah 2:  ",
    "ja_JP": "Step2:  ",
    "ko_KR": "Step2:  ",
    "ms_MY": "Langkah 2:  ",
    "pt_PT": "Etapa 2:  ",
    "ru_RU": "Шаг 2:  ",
    "th_TH": "ขั้นตอนที่ 2:  ",
    "tr_TR": "2. Adım:  ",
    "ur": "مرحلہ 2:",
    "uz": "2-qadam:    ",
    "vi_VN": "Bước 2:  ",
    "zh_CN": "步骤2："
  },
  "guide_how_step3": {
    "HK": "步驟三：",
    "TW": "步驟三：",
    "ar_SA": "الخطوة 3:  ",
    "de_DE": "Schritt 3:  ",
    "en_US": "Step3:  ",
    "es_ES": "Paso 3:  ",
    "fr_FR": "Étape 3 :  ",
    "hi_IN": "Step3:  ",
    "in_ID": "Langkah 3:  ",
    "ja_JP": "Step3:  ",
    "ko_KR": "Step3:  ",
    "ms_MY": "Langkah 3:  ",
    "pt_PT": "Etapa 3:  ",
    "ru_RU": "Шаг 3:  ",
    "th_TH": "ขั้นตอนที่ 3:  ",
    "tr_TR": "3. Adım:  ",
    "ur": "مرحلہ 3:",
    "uz": "3-qadam:    ",
    "vi_VN": "Bước 3:  ",
    "zh_CN": "步骤3："
  },
  "guide_title": {
    "HK": "桌面元件",
    "TW": "桌面小工具",
    "ar_SA": "عنصر واجهة الشاشة الرئيسية",
    "de_DE": "Startbildschirm-Widget",
    "en_US": "Home Screen Widget",
    "es_ES": "Widget para la pantalla de inicio",
    "fr_FR": "Widget d'écran d'accueil",
    "hi_IN": "Home Screen Widget",
    "in_ID": "Widget Layar Beranda",
    "ja_JP": "Home Screen Widget",
    "ko_KR": "Home Screen Widget",
    "ms_MY": "Widget Skrin Utama",
    "pt_PT": "Widget de Tela Inicial",
    "ru_RU": "Виджет рабочего стола",
    "th_TH": "วิดเจ็ตหน้าโฮม",
    "tr_TR": "Ana Ekran Araç Takımı",
    "ur": "ہوم اسکرین وجٹ",
    "uz": "Asosiy ekran vidjeti",
    "vi_VN": "Tiện Ích Màn Hình Chính",
    "zh_CN": "桌面组件"
  },
  "guide_video_title": {
    "HK": "增加程序教學影片",
    "TW": "新增流程教學影片",
    "ar_SA": "تعليمي: كيفية إضافة عناصر الواجهة",
    "de_DE": "Tutorial: So fügst du ein Widget hinzu",
    "en_US": "Tutorial: How to Add a Widget",
    "es_ES": "Tutorial: Cómo añadir un widget",
    "fr_FR": "Tutoriel : Ajouter un widget",
    "hi_IN": "Tutorial: How to Add a Widget",
    "in_ID": "Tutorial: Cara Menambahkan Widget",
    "ja_JP": "Tutorial: How to Add a Widget",
    "ko_KR": "Tutorial: How to Add a Widget",
    "ms_MY": "Tutorial: Cara Menambahkan Widget",
    "pt_PT": "Tutorial: Como Adicionar um Widget",
    "ru_RU": "Руководство по добавлению виджета",
    "th_TH": "การสอนพื้นฐาน: วิธีเพิ่มวิดเจ็ต",
    "tr_TR": "Eğitim: Araç Takımı Nasıl Eklenir",
    "ur": "ٹیوٹوریل: وجٹ شامل کرنے کا طریقہ کار",
    "uz": "Qoʻllanma: Vidjetni qanday qoʻshish mumkin",
    "vi_VN": "Hướng Dẫn: Cách để thêm tiện ích",
    "zh_CN": "添加流程教学视频"
  },
  "topic_hot_post": {
    "HK": "熱門帖子",
    "TW": "熱門貼文",
    "ar_SA": "الرائجة",
    "de_DE": "Angesagt",
    "en_US": "Trending",
    "es_ES": "Tendencia",
    "fr_FR": "Tendances",
    "hi_IN": "Trending",
    "in_ID": "Trending",
    "ja_JP": "Trending",
    "ko_KR": "Trending",
    "ms_MY": "Popular",
    "pt_PT": "Em Alta",
    "ru_RU": "Популярное",
    "th_TH": "มาแรง",
    "tr_TR": "Revaçta",
    "ur": "ٹرینڈنگ",
    "uz": "Trendda",
    "vi_VN": "Hot",
    "zh_CN": "热门帖子"
  },
  "topic_join_num": {
    "HK": "%s人參與討論",
    "TW": "%s人參與討論",
    "ar_SA": "%s من اللاعبين يتناقشون",
    "de_DE": "Diskutierende Spieler: %s",
    "en_US": "%s players discussing",
    "es_ES": "%s jugadores están conversando",
    "fr_FR": "%s joueurs en parlent",
    "hi_IN": "%s players discussing",
    "in_ID": "%s pemain membahas",
    "ja_JP": "%s players discussing",
    "ko_KR": "%s players discussing",
    "ms_MY": "%s pemain berbincang",
    "pt_PT": "%s jogadores discutindo",
    "ru_RU": "Участвуют в обсуждении: %s",
    "th_TH": "ผู้เล่น %s คนกำลังพูดคุย",
    "tr_TR": "%s oyuncu tartışıyor",
    "ur": "‏%s پلیئرز گفتگو کر رہے ہیں",
    "uz": "%s nafa o‘yinchi muhokama qilmoqda",
    "vi_VN": "%s người chơi đang thảo luận",
    "zh_CN": "%s人参与讨论"
  },
  "topic_title": {
    "HK": "話題分享",
    "TW": "話題分享",
    "ar_SA": "مشاركة موضوع",
    "de_DE": "Thema teilen",
    "en_US": "Share Topic",
    "es_ES": "Compartir el tema",
    "fr_FR": "Partage de sujet",
    "hi_IN": "Share Topic",
    "in_ID": "Bagikan Topik",
    "ja_JP": "Share Topic",
    "ko_KR": "Share Topic",
    "ms_MY": "Kongsi Topik",
    "pt_PT": "Compartilhar Tópico",
    "ru_RU": "Поделиться темой",
    "th_TH": "แชร์หัวข้อ",
    "tr_TR": "Konuyu Paylaş",
    "ur": "موضوع شیئر کریں",
    "uz": "Mavzu ulashish",
    "vi_VN": "Chia Sẻ Chủ Đề",
    "zh_CN": "话题分享"
  }
}